import LinearProgress from '@material-ui/core/LinearProgress';

export default function AreaPlaceholder () {
  return (
    <LinearProgress />
  );
}
